// extracted by mini-css-extract-plugin
export default {"wrap":"EG-z","subtitle":"FG-z","contentWrap":"GG-z","imgWrap":"HG-z","heading":"IG-z","copy":"JG-z"};